/* Presentation only: Shopify remains authoritative for cart lines and prices. */
(() => {
  if (window.ypcCartPreorderInstalled) return;
  const imageUrl = document.currentScript?.dataset.yogaspaceImage;
  if (!imageUrl) return;
  window.ypcCartPreorderInstalled = true;
  const message = 'This is a pre-order. Access available 25th December or sooner.';
  const rowSelector = '#cart-drawer-app .cd-cart-item, cart-drawer .cart-item, cart-items .cart-item, #main-cart-items .cart-item';
  const cartUrl = `${window.Shopify?.routes?.root || '/'}cart.js`;
  const originalFetch = window.fetch;
  let cartState = null;
  let cartRequest = 0;
  let cartRefreshTimer;

  function isYogaSpace(row) {
    if (row.dataset.productId) return row.dataset.productId === '10265857949941';
    const title = row.querySelector('.cart-item__name, .cd-cart-item-title');
    if (!title) return false;
    const link = title.closest('a') || row.querySelector('a[href*="/products/yogaspace"]');
    try {
      if (link?.getAttribute('href')) {
        const url = new URL(link.getAttribute('href'), location.href);
        if (/\/products\/yogaspace\/?$/.test(url.pathname)) return true;
      }
    } catch { /* Fall back to the exact product title for app-rendered rows. */ }
    return title.textContent.trim() === 'Yoga Space';
  }

  function render() {

    if (cartState?.items?.length) {
      const hasPhysicalProducts = cartState.items.some(item => item.requires_shipping);
      document.querySelectorAll('#cart-drawer-app .cd-cart-rewards').forEach(reward => {
        reward.hidden = !hasPhysicalProducts;
        reward.style.display = hasPhysicalProducts ? '' : 'none';
      });
    }
    const rows = [...document.querySelectorAll(rowSelector)];
    rows.forEach(row => {
      if (!isYogaSpace(row)) {
        return;
      }
      row.classList.add('ypc-cart-yogaspace');
      const image = row.querySelector('.cd-cart-item-image, .cart-item__image');
      if (image) {
        if (image.getAttribute('src') !== imageUrl) image.setAttribute('src', imageUrl);
        if (image.hasAttribute('srcset')) image.removeAttribute('srcset');
        if (image.getAttribute('alt') !== 'Yoga Space practice app') image.alt = 'Yoga Space practice app';
        if (image.getAttribute('width') !== '1448') image.setAttribute('width', '1448');
        if (image.getAttribute('height') !== '1086') image.setAttribute('height', '1086');
      }
      const details = row.querySelector('.cd-cart-item-info, .cart-item__details');
      if (!details) return;
      const title = details.querySelector('.cd-cart-item-title, .cart-item__name');
      if (title && !details.querySelector('.ypc-cart-preorder-label')) {
        const label = document.createElement('span');
        label.className = 'ypc-cart-preorder-label';
        title.insertAdjacentElement('afterend', label);
      }
      const label = details.querySelector('.ypc-cart-preorder-label');
      if (label && label.textContent !== 'Early Bird Pre-Order') label.textContent = 'Early Bird Pre-Order';
      const plan = [...details.querySelectorAll('.cd-cart-item-detail')].find(option =>
        /\bPlan\s*:/i.test(option.textContent)) || details.querySelector('dl') || title;
      if (!plan) return;
      let note = details.querySelector('.ypc-cart-preorder-note');
      if (!note) {
        note = document.createElement('p');
        note.className = 'ypc-cart-preorder-note';
        note.textContent = message;
      }
      if (plan.nextElementSibling !== note) plan.insertAdjacentElement('afterend', note);
      const itemKey = row.querySelector('[data-cart-item]')?.dataset.cartItem;
      const variantItems = cartState?.items?.filter(candidate => String(candidate.variant_id) === row.dataset.variantId) || [];
      const item = cartState?.items?.find(candidate => candidate.key === itemKey) || (variantItems.length === 1 ? variantItems[0] : null);
      if (item && row.matches('#cart-drawer-app .cd-cart-item')) {
        const format = cents => new Intl.NumberFormat('en-GB', { style: 'currency', currency: cartState.currency || 'GBP' }).format(cents / 100);
        const price = row.querySelector('.cd-cart-item-price');
        if (price && price.childElementCount === 0) {
          const text = format(item.final_line_price);
          if (price.textContent !== text) price.textContent = text;
        }
        document.querySelectorAll('#cart-drawer-app .cd-cart-subtotal-amount').forEach(total => {
          const text = format(cartState.total_price);
          if (total.textContent !== text) total.textContent = text;
        });
      }

    });
  }

  async function refreshCart() {
    const request = ++cartRequest;
    try {
      const response = await originalFetch.call(window, cartUrl, {
        cache: 'no-store', credentials: 'same-origin', headers: { Accept: 'application/json' },
      });
      if (!response.ok) return;
      const nextCart = await response.json();
      if (request !== cartRequest || !Array.isArray(nextCart.items)) return;
      cartState = nextCart;
      schedule();
    } catch { /* Keep the last confirmed cart state while Shopify is unavailable. */ }
  }

  function isCartWrite(input) {
    try {
      return /\/cart\/(add|change|update|clear)(\.js)?\/?$/.test(new URL(typeof input === 'string' ? input : input?.url, location.href).pathname);
    } catch { return false; }
  }

  function scheduleCartRefresh() {
    clearTimeout(cartRefreshTimer);
    cartRefreshTimer = setTimeout(refreshCart, 80);
  }

  let pending = false;
  function schedule() {
    if (pending) return;
    pending = true;
    requestAnimationFrame(() => { pending = false; render(); });
  }
  function start() {
    render();
    new MutationObserver(() => {
      schedule();
      scheduleCartRefresh();
    }).observe(document.body, {
      childList: true, subtree: true, attributes: true,
      attributeFilter: ['src', 'srcset', 'href', 'data-product-id', 'data-variant-id'],
    });
    refreshCart();
  }

  window.fetch = function (...args) {
    const result = originalFetch.apply(this, args);
    if (isCartWrite(args[0]) && result?.then) result.then(refreshCart, () => {});
    return result;
  };
  const xhrOpen = XMLHttpRequest.prototype.open;
  const xhrSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (method, url, ...rest) {
    this.__ypcCartWrite = isCartWrite(url);
    return xhrOpen.call(this, method, url, ...rest);
  };
  XMLHttpRequest.prototype.send = function (...args) {
    if (this.__ypcCartWrite) this.addEventListener('loadend', scheduleCartRefresh, { once: true });
    return xhrSend.apply(this, args);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
  document.addEventListener('yogaspace:offer-updated', event => {
    if (Array.isArray(event.detail?.items)) {
      cartState = event.detail;
      cartRequest++;
      schedule();
    }
  });
  window.addEventListener('pageshow', () => { schedule(); scheduleCartRefresh(); });
  document.addEventListener('shopify:section:load', () => { schedule(); scheduleCartRefresh(); });
})();

